<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
  <g>
    <rect width="64" height="64" fill="none"/>
    <g>
      <path class="filled" d="M47.423,21.458H42.459V16.544a4,4,0,0,0-4-4H19.034A6.469,6.469,0,0,0,12.654,18h-.077v27a6.458,6.458,0,0,0,6.45,6.451h28.4a4,4,0,0,0,4-4v-22A4,4,0,0,0,47.423,21.458ZM19.034,16.544H38.459v4.914H19.034a2.457,2.457,0,0,1,0-4.914ZM47.423,47.456h-28.4a2.454,2.454,0,0,1-2.45-2.451V24.973a6.423,6.423,0,0,0,2.457.485H47.423Z" fill="#035ce0"/>
      <path class="filled" d="M40.459,39.8a3.347,3.347,0,1,0-3.347-3.347A3.347,3.347,0,0,0,40.459,39.8Z" fill="#035ce0"/>
    </g>
  </g>
</svg>
